import InfoIcon from '@mui/icons-material/Info';
import { Typography, Box, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';

FormTitle.propTypes = {
  fieldAttributes: PropTypes.object,
  isRequired: PropTypes.bool,
};

export default function FormTitle({ fieldAttributes, isRequired }) {
  const words = fieldAttributes?.questionTitle?.split(' ');
  const lastWord = words?.pop();

  const variant =
    fieldAttributes.fieldType === 'title' ? 'h6' : fieldAttributes.fieldType === 'file' ? 'subtitle3' : 'subtitle2';

  return (
    !fieldAttributes?.noTitle && (
      <Box sx={{ lineHeight: 1 }}>
        <Typography variant={variant} color="text.secondary">
          {words?.join(' ')}{' '}
          <Box sx={{ display: 'inline-flex' }}>
            {lastWord}
            {fieldAttributes.information && (
              <Tooltip placement="top" arrow title={fieldAttributes.information} sx={{ fontSize: '1rem' }}>
                <InfoIcon color="secondary" fontSize="small" />
              </Tooltip>
            )}
          </Box>
          {isRequired && (
            <Box component="span" sx={{ color: 'error.main', ml: '2px' }}>
              *
            </Box>
          )}
        </Typography>
      </Box>
    )
  );
}
